import { FundAdminServiceDocumentType } from "~/graphql/mainEnums";

export const isNullOrUndefined = (value: any): boolean => {
  return value === null || value === undefined;
};

export const getDocumentTypeByServiceType = (
  requestType: string | null | undefined,
): FundAdminServiceDocumentType => {
  if (isNullOrUndefined(requestType)) return FundAdminServiceDocumentType.Additional;

  let type = FundAdminServiceDocumentType.Additional;
  switch (requestType) {
    case "Fundraise":
      type = FundAdminServiceDocumentType.FundraiseSubscription;
      break;
    case "Position Transfer":
      type = FundAdminServiceDocumentType.PositionTransfer;
      break;
    case "Distribution":
      type = FundAdminServiceDocumentType.DistributionDetail;
      break;
    case "Capital Call":
      type = FundAdminServiceDocumentType.CapitalCallDetail;
      break;
    case "Invoice Payment":
      type = FundAdminServiceDocumentType.VendorPaymentInvoice;
      break;
    case "Tax Documents":
      type = FundAdminServiceDocumentType.Tax;
      break;
    case "Investor email":
    case "Document share":
      type = FundAdminServiceDocumentType.InvestorCommunication;
      break;
    default:
      break;
  }
  return type;
};
